// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «OKR» (OKR, ключ `okr`, група `management`). */
export const okrManifest: IModuleManifest = {
  key: 'okr',
  group: 'management',
  slug: 'okr',
  prefix: 'OKR',
  name: { en: 'OKR', uk: 'OKR' },
  entities: [
    { key: 'okr', slug: 'okr', name: { en: 'OKR', uk: 'OKR' }, main: true },
    { key: 'objective_key_result', slug: 'objective-key-result', name: { en: 'Objective Key Results', uk: 'Ключові результати' }, main: false },
    { key: 'objective_check_in', slug: 'objective-check-in', name: { en: 'Objective Check-ins', uk: 'Перевірки прогресу' }, main: false },
    { key: 'objective_project', slug: 'objective-project', name: { en: 'Objective Projects', uk: 'Проєкти' }, main: false },
  ],
  loadState: () => import('./state/okrSlice').then((m) => m.okrSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
